export default __webpack_public_path__ + "static/media/select-12.6dc327f9.svg";